import Vue from 'vue'
import Vuex from 'vuex'
import invoice from './invoice/index'
import confirmOrder from './confirmOrder/index'
import address from './address/index'
import search from './search/index'

Vue.use(Vuex)
export default new Vuex.Store({
    state: {},
    getters: {},
    actions: {},
    modules: {
        invoice,
        confirmOrder,
        address,
        search
    },
    strict: true,
    namespaced: true
})
